import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ComponentsService} from 'src/app/services/components.service';
import {ToastService} from '../../toast/toast.service';

@Component({
  selector: 'app-component-instance',
  templateUrl: './component-instance.component.html',
  standalone: false
})
export class ComponentInstanceComponent {

  componentid !: number;
  idproyecto !: number;
  usuario !: string;
  idioma !: string;
  formComp: FormGroup;
  intSfdcQuotelineId !: number;

  constructor(public modal: NgbActiveModal,
              private __componentService: ComponentsService,
              private __toastService: ToastService,
              private fb: FormBuilder) {
    this.formComp = this.fb.group({
      descriptionEn: ['', Validators.required],
      descriptionEs: ['', Validators.required],
      descriptionPt: ['', Validators.required]
    });
  }

  isValid(controlName: any) {
    let ep: any;
    ep = this.formComp.get(controlName);
    return ep.invalid && ep.touched;
  }

  newComponentInstance() {

    let component = {
      COMPONENTID: this.componentid,
      INT_SFDC_QUOTE_LINE_ID: this.intSfdcQuotelineId,
      usuario: this.usuario
    }
    this.__componentService.actionInstanceComponent(component, 'I').subscribe((resp: any) => {
      console.log(resp)
      if (resp['an_resultado'] == 0) {
        this.__toastService.show(resp['ac_mensaje'], {type: 'success'});
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      } else {
        this.__toastService.show(resp['ac_mensaje'], {type: 'error'});
      }
    })
  }

}
